import React from "react";

import "./Icon.scss";

export type AlertIconProps = {
  cx?: string;
  isNew?: boolean;
  onClick?: any;
};

export const AlertIcon: React.FC<AlertIconProps> = ({
  cx = "",
  isNew = false,
  onClick,
}) => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`Alert ${cx}`}
      onClick={onClick}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.885 15.04c0 1.06.366 2.08 1.003 2.9l.849 1.1c.617.78.077 1.92-.868 1.92H9.123c-.945 0-1.466-1.16-.868-1.92l.868-1.1a4.626 4.626 0 0 0 1.003-2.9V13c0-2.44 1.64-4.46 3.838-4.96v-.96c0-.6.463-1.08 1.041-1.08.579 0 1.042.48 1.042 1.08v.96c2.199.5 3.838 2.54 3.838 4.96v2.04zM17.513 22c0 1.44-1.119 2.6-2.508 2.6-1.388 0-2.507-1.16-2.507-2.6h5.015z"
        fill="#111"
      />
      {isNew && <circle cx="24" cy="7" r="2" fill="#111" />}
    </svg>
  );
};
